import React from 'react';
import { Colors } from 'library';
import { Card, Icon, Modal, PillButton, Row, Stack, Text, Title } from 'library/ui';
import UserAttributesApi from 'shared/UserAttributesApi';
import { useUserContext } from 'UserContext';

import type { SubPoolSummary } from '../types';
import { getElcIcon } from './elcIcons';
import { FadeSlideIn, AnimatedLogo, HeaderSection } from './elcStyles';

export function ELCWelcomeModal({
    partner,
    open,
    onClose,
}: {
    partner: SubPoolSummary;
    open: boolean;
    onClose: () => void;
}) {
    const { user, refreshAlreadyLoggedInUser } = useUserContext();

    function closeModal() {
        if (user?.sub_pool_welcome_attribute) {
            UserAttributesApi.remove(user?.sub_pool_welcome_attribute.id).then(refreshAlreadyLoggedInUser);
        }
        onClose();
    }

    if (!open) {
        return null;
    }

    return (
        <Modal onClose={closeModal} width={520} padding="none">
            <HeaderSection gap="sm" align="center" padding="lg">
                <FadeSlideIn delay={150}>
                    <Text size="xl" weight="bold" tone="overlay">
                        Welcome to Tandem!
                    </Text>
                </FadeSlideIn>
                <FadeSlideIn delay={250}>
                    <Text tone="overlay">You&apos;re part of something special.</Text>
                </FadeSlideIn>
            </HeaderSection>
            <Stack gap="md" padding="lg">
                <FadeSlideIn delay={200}>
                    <Card tone="muted" padding="md">
                        <Stack gap="sm" align="center">
                            <AnimatedLogo
                                src={partner.logo_url ?? ''}
                                alt={partner.full_name ?? partner.name}
                                width={partner.logo_width_modal ?? undefined}
                            />
                            <Title size="h2">{`${partner.name}'s Substitute Pool`}</Title>
                            <Text size="sm" tone="secondary">
                                Powered by Tandem
                            </Text>
                            <Text align="center">{partner.description}</Text>
                        </Stack>
                    </Card>
                </FadeSlideIn>
                <Stack gap="sm">
                    {partner.benefits.map((benefit, index) => {
                        const ElcIcon = getElcIcon(benefit.icon);
                        return (
                            <FadeSlideIn key={benefit.text} delay={350 + index * 100}>
                                <Row gap="sm" align="center">
                                    {ElcIcon && (
                                        <Icon
                                            icon={ElcIcon}
                                            size="sm"
                                            bgColor={Colors.turquoise}
                                            iconColor={Colors.white}
                                        />
                                    )}
                                    <Text>{benefit.text}</Text>
                                </Row>
                            </FadeSlideIn>
                        );
                    })}
                </Stack>
                <FadeSlideIn delay={700}>
                    <Row justify="center" fullWidth>
                        <PillButton onClick={closeModal}>Get Started</PillButton>
                    </Row>
                </FadeSlideIn>
            </Stack>
        </Modal>
    );
}
